import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import {
  useCallback, useMemo, useState
} from "react";
import { CREATE_FEEDBACK, GET_FEEDBACK } from "../components/Feedback/feedback.qql";
import { appRoutes } from "../constants/routes";
import { STORAGE_KEY } from "../constants/video";

const useFeedback = () => {
  const navigate = useNavigate();
  const appointmentId = secureLocalStorage.getItem(STORAGE_KEY) as number;
  const [key, setKey] = useState("");

  const [createFeedback, { loading: createFeedbackLoading }] = useMutation(CREATE_FEEDBACK, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data.createFeedback !== null) {
        setKey(data.createFeedback.page_token);
      }
    }
  });

  const {
    loading: getFeedbackLoading
  } = useQuery<{
    feedback: {
      page_token: string;
    }
  }>(GET_FEEDBACK, {
    fetchPolicy: "no-cache",
    variables: {
      id: appointmentId
    },
    onCompleted: (data) => {
      if (data.feedback === null) {
        createFeedback({
          variables: {
            id: appointmentId
          }
        });
      } else {
        setKey(data.feedback.page_token);
      }
    }
  });

  const handleFeedback = useCallback(() => {
    navigate(`${appRoutes.feedback}?key=${key}`);
  }, [key]);

  const isFeedbackLoading = useMemo(
    () => createFeedbackLoading || getFeedbackLoading,
    [createFeedbackLoading, getFeedbackLoading]
  );

  return {
    isFeedbackLoading,
    handleFeedback,
    key
  };
};

export default useFeedback;
